import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import thunk from 'redux-thunk'
import { gaMiddleware, gaMetaReducer } from 'Checkout/Redux/Trackers/TrackGA'
import { segmentMiddleware, segmentMetaReducer } from 'Checkout/Redux/Trackers/segment.io'
import camper from 'Checkout/Redux/Reducers/Camper'
import campground from 'Checkout/Redux/Reducers/Campground'
import cartSlice from 'Checkout/Redux/Slices/CartSlice'
import details from 'Checkout/Redux/Reducers/Details'
import errors from 'Checkout/Redux/Reducers/Errors'
import initialState from 'Checkout/Redux/InitialState'
import options from 'Checkout/Redux/Reducers/Options'
import payment from 'Checkout/Redux/Reducers/Payment'
import search from 'Checkout/Redux/Reducers/Search'

const useStore = slug => {
  const persistConfig = {
    key: `checkout?c=${slug}`,
    storage: storageSession,
    whitelist: ['cart', 'campground', 'details', 'options', 'payment', 'search'],
  }

  const reducers = combineReducers({
    search, camper, campground, cart: cartSlice, details, errors, options, payment, gaMetaReducer,
    segmentMetaReducer,
  })

  const reducersPersisted = persistReducer(persistConfig, reducers)

  const middlewares = [thunk, gaMiddleware]
  if (window.analytics) middlewares.push(segmentMiddleware)
  // disable dev tools in staging & production environments and use the `compose` as fallback
  const composeEnhancers = (!['production', 'staging'].includes(process.env.NODE_ENV) &&
                            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

  const store = createStore(reducersPersisted, initialState, composeEnhancers(applyMiddleware(...middlewares)))
  const persistor = persistStore(store)

  const purgeStore = () => persistor.purge()

  return { persistor, purgeStore, store }
}

export default useStore
